import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import axios from 'axios';
import PropTypes from 'prop-types';
/**
 * Validator
 */
import InputError from '../InputError';
import Validator from '../../libs/Validator';
import * as MESSAGES from '../../libs/Messages';
import Progress from '../Progress';


export default class FileUploaded extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isError: false,
            errorMessage: null,
            errors: {},
        }
    }

    componentDidMount() {

    }

    convertByte = (filesize) => {
        var return_value = '';
        if (filesize < 1000000) {
            return_value = Math.floor(parseInt(filesize) / 1000) + 'KB';
        } else {
            return_value = Math.floor(parseInt(filesize) / 1000000) + 'MB';
        }
        return return_value;
    }

    render() {
        return (
            <div className={`claim-uploaded-element ${this.props.fileInfo.uploaded ? 'success' : ''} ${this.props.fileInfo.uploadError ? 'error' : ''}`}>
                <div className="progress_bg" style={{ "width": this.props.fileInfo.uploadProgress + "%" }}></div>
                <div className="row">
                    <div className="col-6 cut-text text-left">{this.props.fileInfo.file.name}</div>
                    <div className="col-4 cut-text text-left">{this.props.fileInfo.fileType}</div>
                    {/* <div className="col-2">{this.convertByte(this.props.fileInfo.file.size)}</div> */}
                    <div className="col-2 text-right">
                        <a className={`claim-upload-cancel-btn ${(this.props.fileInfo.uploaded || this.props.isUploading) ? 'd-none' : ''}`} onClick={this.props.onDeleteFile.bind(this, this.props.fileInfo.file.name, this.props.fileIndex)}></a>
                    </div>
                </div>
            </div>
        );
    }
}

FileUploaded.propTypes = {
    onDeleteFile: PropTypes.func
};